// ============================================================
// SINGARAA - Centralized Brand Constants
// ============================================================

export const BRAND = {
  name: 'Singaraa',
  tagline: 'A New Standard of Snacking.',
  description: 'Premium dry roasted peanuts crafted with simplicity, quality and the warmth of Indian snacking traditions.',
  whatsapp: '919106302759',
  phone: '+919106302759',
  phoneDisplay: '+91 91063 02759',
  email: 'singaraa.in@gmail.com',
  address: 'Ground Floor, Building No. 5, City Survey No. 664, New Fatehwadi, Azadnagar, Sarkhej, Ahmedabad - 382210, Gujarat, India',
  mapsUrl: 'https://maps.app.goo.gl/DuWdqEm5WbeD7dd28',
  website: 'singaraa.in',
};

export const NAVIGATION = [
  { label: 'Home', href: '/' },
  { label: 'Product', href: '/product' },
  { label: 'Why Singaraa', href: '/why-singaraa' },
  { label: 'Our Story', href: '/story' },
  { label: 'Contact', href: '/contact' },
];

export const SOCIAL_LINKS = [
  { label: 'Instagram', href: 'https://www.instagram.com/singaraa.in', icon: 'Instagram' },
  { label: 'Facebook', href: 'https://www.facebook.com/share/1Ehxp4DRev/', icon: 'Facebook' },
  { label: 'YouTube', href: 'https://youtube.com/@singaraa', icon: 'Youtube' },
  { label: 'Threads', href: 'https://www.threads.com/@singaraa.in', icon: 'AtSign' },
  { label: 'Email', href: 'mailto:singaraa.in@gmail.com', icon: 'Mail' },
];

export const PRODUCT = {
  name: 'Singaraa KHARISING - Roasted Peanuts (Salted)',
  tagline: 'Crunchy. Fresh. Taste of Kathiyawad.',
  description: 'A premium everyday snack made from carefully selected peanuts and roasted to bring out their natural flavour.',
  weight: '500 gm',
  taste: 'Nutty • Crunchy • Naturally Delicious',
  bestFor: 'Office Snacks • Travel • Evening Craving • Everyday Munching',
  packaging: 'Premium vacuum packaging to lock in freshness and crunch.',
  price: 249,
  ingredients: 'Premium Peanuts, Iodized Salt.',
  fssai: '20726053000107',
  shelfLife: 'Best before 6 months from the date of packing.',
};

export const PRICING_TIERS = [
  {
    id: '1-packet',
    packets: 1,
    quantityLabel: '1 Packet',
    title: '1 Packet (500g)',
    weight: '500g',
    weightLabel: '500g',
    weightInGrams: 500,
    normalPrice: 249,
    finalPrice: 249,
    saving: 0,
    badge: null,
    popular: false,
    description: '1 Vacuum sealed 500g pouch of Singaraa KHARISING.',
  },
  {
    id: '2-packets',
    packets: 2,
    quantityLabel: '2 Packets',
    title: '2 Packets (1kg)',
    weight: '1kg',
    weightLabel: '1kg (2 x 500g)',
    weightInGrams: 1000,
    normalPrice: 499,
    finalPrice: 399,
    saving: 100,
    badge: 'Popular',
    popular: true,
    description: '2 Vacuum sealed 500g pouches. Ideal for daily tea-time & office cravings.',
  },
  {
    id: '3-packets',
    packets: 3,
    quantityLabel: '3 Packets',
    title: '3 Packets (1.5kg)',
    weight: '1.5kg',
    weightLabel: '1.5kg (3 x 500g)',
    weightInGrams: 1500,
    normalPrice: 749,
    finalPrice: 599,
    saving: 150,
    badge: 'Save ₹150',
    popular: false,
    description: '3 Vacuum sealed 500g pouches. Great for family snacking and pantry stock.',
  },
  {
    id: '4-packets',
    packets: 4,
    quantityLabel: '4 Packets',
    title: '4 Packets (2kg)',
    weight: '2kg',
    weightLabel: '2kg (4 x 500g)',
    weightInGrams: 2000,
    normalPrice: 999,
    finalPrice: 799,
    saving: 200,
    badge: 'Save ₹200',
    popular: false,
    description: '4 Pouches (2kg). Perfect balance of freshness and value.',
  },
  {
    id: '5-packets',
    packets: 5,
    quantityLabel: '5 Packets',
    title: '5 Packets (2.5kg)',
    weight: '2.5kg',
    weightLabel: '2.5kg (5 x 500g)',
    weightInGrams: 2500,
    normalPrice: 1249,
    finalPrice: 999,
    saving: 250,
    badge: 'Best Value',
    popular: false,
    description: '5 Pouches (2.5kg). Best value pack for everyday peanut lovers.',
  },
  {
    id: '10-packets',
    packets: 10,
    quantityLabel: '10 Packets',
    title: '10 Packets (5kg)',
    weight: '5kg',
    weightLabel: '5kg Box (10 x 500g)',
    weightInGrams: 5000,
    normalPrice: 2499,
    finalPrice: 1999,
    saving: 500,
    badge: 'Mega Saver',
    popular: false,
    description: '10 Pouches (5kg) master carton. Best for events, gifting & bulk use.',
  },
];

export const PRODUCT_HIGHLIGHTS = [
  {
    title: 'Premium Quality',
    description: 'Carefully selected peanuts for consistent taste and quality.',
    icon: 'Award',
  },
  {
    title: 'Light Roasted',
    description: 'Lightly roasted to bring out a naturally delicious crunch.',
    icon: 'Flame',
  },
  {
    title: 'High Protein',
    description: 'A naturally protein-rich snack for everyday consumption.',
    icon: 'Dumbbell',
  },
  {
    title: 'Vacuum Packed',
    description: 'Sealed in airtight vacuum pouches to lock in roaster-fresh aroma and crunch.',
    icon: 'PackageCheck',
  },
];

export const PRODUCT_BADGES = [
  'Vacuum Packed',
  'High Protein',
  'Source of Fiber',
  'Light Roasted',
  'Cholesterol Free',
  'Vegetarian',
];

export const WHY_BENEFITS = [
  {
    title: 'Healthy Fats',
    description: 'Peanuts contain naturally occurring healthy fats.',
    icon: 'Heart',
  },
  {
    title: 'Everyday Energy',
    description: 'A natural source of energy for your daily routine.',
    icon: 'Zap',
  },
  {
    title: 'Nutrient Packed',
    description: 'Rich in essential nutrients your body needs.',
    icon: 'Leaf',
  },
  {
    title: 'Natural Energy',
    description: 'Fuel your day with wholesome, natural ingredients.',
    icon: 'Sun',
  },
  {
    title: 'Crunchy & Delicious',
    description: 'Every bite delivers a satisfying, delicious crunch.',
    icon: 'Sparkles',
  },
];

export const BENEFITS_FULL = [
  {
    title: 'Premium Peanuts',
    description: 'Selected for quality and consistency.',
    icon: 'Award',
  },
  {
    title: 'Dry Roasted',
    description: 'Roasted for natural flavour and crunch.',
    icon: 'Flame',
  },
  {
    title: 'Protein Rich',
    description: 'A naturally protein-rich snack.',
    icon: 'Dumbbell',
  },
  {
    title: 'Everyday Product',
    description: 'Suitable for everyday snacking.',
    icon: 'Coffee',
  },
  {
    title: 'Indian Taste',
    description: 'Rooted in familiar Indian snacking culture.',
    icon: 'MapPin',
  },
  {
    title: 'Source of Fiber',
    description: 'Packed with dietary fiber for a healthy gut.',
    icon: 'Leaf',
  },
];

export const FOUNDERS = [
  {
    name: 'Sahil',
    role: 'Founder & CEO',
    description: 'Leading Company Vision, Brand Building, Business Strategy & Market Expansion.',
  },
  {
    name: 'Hemang',
    role: 'Co-Founder & Managing Director',
    description: 'Leading Operations, Financial Planning, Execution & Business Administration.',
  },
];

export const STORY_TIMELINE = [
  {
    label: 'THE BEGINNING',
    title: 'Two Brothers, One Dream',
    description: 'Singaraa began with two brothers, Sahil & Hemang, and a simple dream to bring back the taste of moments that feel like home.',
  },
  {
    label: 'THE INSPIRATION',
    title: 'Taste of Kathiyawad',
    description: 'Inspired by Kathiyawad, family gatherings, and peanuts shared with love.',
  },
  {
    label: 'THE PROCESS',
    title: 'Honesty & Care',
    description: 'We carefully roast every peanut with honesty and care.',
  },
  {
    label: 'THE VISION',
    title: 'Sharing Our Roots',
    description: 'Because every bite carries our roots, our memories, and a feeling we hope becomes a beautiful part of yours.',
  },
];

export const NUTRITION_DATA = [
  { label: 'Serving Size', value: '30g (approx.)' },
  { label: 'Approx. Values Per', value: '100g' },
  { label: 'Energy', value: '585 kcal' },
  { label: 'Protein', value: '25.8 g' },
  { label: 'Total Fat', value: '49.2 g' },
  { label: 'Saturated Fat', value: '6.8 g' },
  { label: 'Trans Fat', value: '0 g' },
  { label: 'Cholesterol', value: '0 mg' },
  { label: 'Carbohydrates', value: '16.1 g' },
  { label: 'Dietary Fiber', value: '8.5 g' },
  { label: 'Total Sugars', value: '4.7 g' },
  { label: 'Added Sugars', value: '0 g' },
  { label: 'Sodium', value: '380 mg' },
];
